import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import styles from './index.scss';

export default function Button(props) {
  const { className, disabled, onClick, text } = props;

  const [fontLoaded, setFontLoaded] = useState(false);
  useEffect(() => {
    const loadFont = async () => {
      // dynamically import the font CSS to ensure code splitting
      await import('./font.css');
      setFontLoaded(true);
    };
    loadFont();
  }, []);

  return (
    <button
      type="button"
      className={clsx(
        className,
        'samsung-button',
        disabled && 'disabled',
        styles.button,
        disabled && styles.disabled
      )}
      onClick={(event) => !disabled && onClick?.(event)}
    >
      <span
        className="samsung-button-label"
        style={{
          fontFamily: fontLoaded ? 'SamsungSharpSans-Bold' : undefined,
          fontWeight: 'bold',
          fontSize: '18px',
          lineHeight: '38px',
        }}
      >
        {text}
        <span
          style={{
            color: '#1428A0',
          }}
        >
          {' Samsung'}
        </span>
      </span>
    </button>
  );
}
